// @flow
import type { PendingRefundReason } from "mmb/records/bookingInput"

export const PENDING_REFUND_REASONS = {
  TECHNICAL_ISSUE: "technical_issue",
  GENERAL: "general",
  PRICE_CHANGED: "price_changed",
  SOLD_OUT: "sold_out",
  DUPLICATES: "duplicates",
  SCHEDULE_CHANGE: "schedule_change",
  INSURANCE: "insurance", // modal not shown
  MASS_REFUND: "mass_refund", // modal not shown
}

export const getRefundReasonDescriptionKey = (
  reason: PendingRefundReason,
  isSingleCarrier: boolean,
  showOptionDetailsCorrection: boolean,
) => {
  if (showOptionDetailsCorrection) {
    return __("mmb.pending_refunds.modal.description.correction_option")
  }

  switch (reason) {
    case PENDING_REFUND_REASONS.TECHNICAL_ISSUE:
      return __("mmb.pending_refunds.modal.description.technical_issue")

    case PENDING_REFUND_REASONS.PRICE_CHANGED:
      return __("mmb.pending_refunds.modal.description.price_change.pay")

    case PENDING_REFUND_REASONS.SOLD_OUT:
      return isSingleCarrier
        ? __("mmb.pending_refunds.modal.description.sold_out.single_carrier")
        : __("mmb.pending_refunds.modal.description.sold_out.multiple_carriers")

    case PENDING_REFUND_REASONS.DUPLICATES:
      return __("mmb.pending_refunds.modal.description.duplicates")

    case PENDING_REFUND_REASONS.SCHEDULE_CHANGE:
      return __("mmb.pending_refunds.modal.description.schedule_change")

    case PENDING_REFUND_REASONS.GENERAL:
    default:
      return __("mmb.pending_refunds.modal.description.general")
  }
}
